import { observer } from 'mobx-react';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import CopyButton from 'src/view/components/Controls/CopyButton/CopyButton';
import AggregatorManager from 'src/view/components/AggregatorManager/AggregatorManager';
import { AGGREGATOR_NAMES, AGGREGATORS } from 'src/constants/aggregators';
import './style.scss';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';

interface IHealthcheck {
  title: string;
  data: undefined | string | number;
}

const Healthcheck: React.FC<IHealthcheck> = (item: IHealthcheck): JSX.Element | null => {
  if (!item.data) return null;

  return (
    <OrderBlockItem title={item.title} className="details-healthcheck__item" titleClassName="details-healthcheck__item-title">
      <div className="details-healthcheck__item-container d-flex flex-row">
        <p className="details-healthcheck__item-text family-semibold text-size-18 color-dark">{item.data}</p>
        <CopyButton data={item.data} size={18} tooltipMessage="copied" />
      </div>
    </OrderBlockItem>
  );
};

const DetailsHealthcheck: React.FC = observer((): JSX.Element | null => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  const aggregatorName = (key?: AGGREGATORS | null) => {
    if (!key || !AGGREGATOR_NAMES[key]) {
      return '-';
    }

    if ([AGGREGATORS.JAHEEZ, AGGREGATORS.CAREEM, AGGREGATORS.HUNGER_STATION, AGGREGATORS.TO_YOU, AGGREGATORS.KEETA].includes(key)) {
      return 'aggregator';
    }

    return AGGREGATOR_NAMES[key];
  };

  if (
    !orderStore.order.payment_id &&
    !orderStore.order.foodics_id &&
    !orderStore.order.takergo?.reference_id &&
    !orderStore.order.dook_id &&
    !orderStore.order?.aggregator_id &&
    !orderStore.order.aggregator?.tenant_id &&
    !orderStore.order.aggregator?.external_transaction_id
  ) {
    return null;
  }

  return (
    <div className="details-healthcheck">
      {/* block title */}
      <OrderBlockHeader title="healthcheck" />
      <ul className="d-flex flex-column">
        {/* payment transaction id */}
        <AggregatorManager aggregator={orderStore.order?.aggregator_key} sectionName="healthcheck">
          <Healthcheck title="checkout_id" data={orderStore.order.payment_id} />
        </AggregatorManager>
        {/* NOTE: foodics_id used for Kudu and Foodics */}
        <Healthcheck title={`${orderStore.order.pos_system_name?.toLowerCase() || ''}_id`} data={orderStore.order.foodics_id} />
        <Healthcheck title={`taker_ap_order_details_foodics_reference_number`} data={orderStore.order.foodics_reference} />
        <Healthcheck title={`tenant_technical_id`} data={orderStore.order.aggregator?.tenant_id} />
        <Healthcheck title={`tenant_transaction_id`} data={orderStore.order.aggregator?.external_transaction_id} />
        {orderStore.order?.aggregator_key ? (
          <Healthcheck title={`${aggregatorName(orderStore.order?.aggregator_key).toLowerCase()}_id`} data={orderStore.order?.aggregator_id ?? ''} />
        ) : null}
        <AggregatorManager aggregator={orderStore.order?.aggregator_key} sectionName="healthcheck">
          {/* takerGO id */}
          <Healthcheck title="taker_go_id" data={orderStore.order.takergo?.reference_id} />
          {/* dook id */}
          <Healthcheck title="Dook ID" data={orderStore.order.dook_id} />
        </AggregatorManager>
      </ul>
    </div>
  );
});

export default DetailsHealthcheck;
